import { SectionHeading } from "@/components/ui-ext/SectionHeading";
import { siteConfig } from "@/config/site";

export const HOME_FAQ = [
  {
    q: `Are you actually based in ${siteConfig.contact.address.city}, ${siteConfig.contact.address.state}?`,
    a: `Yes. ${siteConfig.name} is headquartered at ${siteConfig.contact.address.street}, ${siteConfig.contact.address.city}, ${siteConfig.contact.address.state} ${siteConfig.contact.address.zip} in South ${siteConfig.contact.address.city}, and we serve businesses across Downtown ${siteConfig.contact.address.city}, South Congress, East ${siteConfig.contact.address.city}, the Domain, Zilker, Round Rock, Cedar Park, Pflugerville, Georgetown and Leander. Founder ${siteConfig.founder.name} runs strategy on every account personally — you'll never be handed to a junior AM.`,
  },
  {
    q: `How long before we see measurable results in the ${siteConfig.contact.address.city} market?`,
    a: `Technical SEO wins land in the first 30–60 days. Local pack and Google Business Profile movement typically starts month 2, organic ranking and traffic momentum from month 3, with compounding growth from month 4–6. Every engagement includes a baseline dashboard and a leading-indicator report so ${siteConfig.contact.address.city} business owners see progress long before it hits revenue.`,
  },
  {
    q: "Do you guarantee Google rankings?",
    a: `No — anyone who guarantees a specific Google rank is misleading you. Google owns the SERP, and ${siteConfig.contact.address.city} is a competitive market. What we guarantee is process quality, dated deliverables, weekly transparency, and a KPI dashboard your leadership can audit at any time — the same standard we hold for every Foreign Affairs Auto, Lynx Systems, Air Tech Pro and Carage Auto engagement.`,
  },
  {
    q: "How do you optimize for ChatGPT, Perplexity and Google AI Overviews?",
    a: `Our AI Search Readiness Scorecard grades every priority page on entity clarity, citation surface area, answer-shape fit, and evidence density. We layer LocalBusiness, Service and FAQ schema, publish first-party data and dated author bios, then track AI-cited pages through Semrush AI Search and Profound. ${siteConfig.contact.address.city} service brands are seeing citation growth across ChatGPT Search and Perplexity within 60–90 days.`,
  },
  {
    q: `What does SEO cost for an ${siteConfig.contact.address.city} small business?`,
    a: `Local SEO programs for ${siteConfig.contact.address.city} small businesses start at $6K/month and scale to $25K+/month for national plus AI-search programs with full technical, content and digital PR components. That's in line with reputable ${siteConfig.contact.address.city} SEO agencies — you're paying for a documented framework and named, verifiable case studies, not a 300-page audit template.`,
  },
  {
    q: `Do you serve businesses outside ${siteConfig.contact.address.city} — Round Rock, Cedar Park, Pflugerville?`,
    a: `Yes. We serve the full ${siteConfig.contact.address.city} metro and Central Texas: Round Rock, Cedar Park, Pflugerville, Georgetown, Leander, Buda, Kyle, San Marcos and Lakeway. Each nearby-city engagement gets its own location landing page with unique copy, neighborhood entity signals, and matching LocalBusiness schema so you rank locally, not just "near ${siteConfig.contact.address.city}."`,
  },
  {
    q: "Do you work with our existing content or dev team?",
    a: `Almost always. We prefer to embed with your team: ${siteConfig.name} handles strategy, briefs, technical audits and reporting; your team executes content and dev on a shared roadmap. We can also deliver end-to-end when your ${siteConfig.contact.address.city} business doesn't have in-house capacity.`,
  },
  {
    q: "Are the case studies on this site real?",
    a: `Yes — every one. Named ${siteConfig.contact.address.city} and Central Texas clients, dated performance windows, real Google Search Console and Semrush screenshots. Nothing on this site is stock, invented, or under NDA-with-a-wink.`,
  },
];

export function HomeFAQ() {
  return (
    <section className="container-page py-24 md:py-32">
      <div className="grid lg:grid-cols-[1fr_1.4fr] gap-14">
        <SectionHeading
          eyebrow={`${siteConfig.contact.address.city} SEO FAQ`}
          title={<>Questions ${siteConfig.contact.address.city} business owners ask on <span className="text-gradient">every discovery call</span>.</>}
          intro={`If yours isn't here, ask it directly on the call — ${siteConfig.founder.name} answers every question with the same precision we bring to a technical SEO audit.`}
        />
        <div className="divide-y divide-border border-y border-border">
          {HOME_FAQ.map((f, i) => (
            <details
              key={f.q}
              className="group py-5"
              {...(i === 0 ? { open: true } : {})}
            >
              <summary className="cursor-pointer list-none flex items-start justify-between gap-6">
                <span className="font-display text-lg text-foreground pr-4">
                  {f.q}
                </span>
                <span
                  aria-hidden
                  className="mt-1 h-6 w-6 rounded-full border border-border-strong flex items-center justify-center text-primary transition-transform group-open:rotate-45 shrink-0"
                >
                  +
                </span>
              </summary>
              <p className="mt-3 text-sm text-muted-foreground leading-relaxed max-w-2xl">
                {f.a}
              </p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
